<template>
    <div v-loading="loading.actions['timetable']">
        <el-row>
            <el-col :lg="12" :sm="24" :xl="12" class="grid">
                <el-button-group>
                    <el-button
                            @click="prevWeek"
                            icon="el-icon-arrow-left"
                    >
                        上一周
                    </el-button>
                    <el-button
                            @click="current"
                            icon="el-icon-date"
                    >
                        本周
                    </el-button>
                    <el-button
                            @click="nextWeek"
                            icon="el-icon-arrow-right"
                    >
                        下一周
                    </el-button>
                </el-button-group>
            </el-col>
            <el-col :lg="10" :sm="24" :xl="10" class="grid">
                <span>週次快選: </span>
                <el-date-picker
                        :clearable="false"
                        :editable="false"
                        :pickerOptions="pickerOptions"
                        @change="weekChange"
                        format="週 WW"
                        placeholder="請選擇週次"
                        type="week"
                        v-model="week"
                >
                </el-date-picker>
            </el-col>
        </el-row>
        <h3 style="text-align: center;">期間: {{weeks[0] | shortDate}} ~ {{weeks[6] | shortDate}}</h3>
        <timetable
                :is-date-selectable="isValidDate"
                :on-cell-click="onCellClick"
                :periodsDefs="periodsDefs"
                :timePlots="timePlots"
                :weeks="weeks"
        ></timetable>
    </div>
</template>

<script>
    import Timetable from '../Timetable/TimetableContainer';
    import QueryMixin from './QueryMixin';
    import {isPeriodCollided} from '../../utilities';

    export default {
        name: 'TimetableQueryOfOneRoom',
        props: {
            selectedRoomId: {
                type: Number,
                default: 0
            },
        },
        mixins: [QueryMixin],
        components: {
            Timetable
        },

        watch: {
            async selectedRoomId(current) {
                this.roomId = current;
                await this.refresh();
            }
        },

        methods: {
            onCellClick(data) {
                const {isValid, isPast, date, period, weekday} = data;
                if (!isValid || isPast || !this.isValidDate(date)) return;

                const timeSlotOfWd = this.timePlots[weekday > 5 ? weekday + 1: weekday];
                if(!timeSlotOfWd
                    .some(ts => isPeriodCollided(ts, {weekday, begin: period, end: period}))){
                    this.$emit('cell-click', data);
                }
            }
        },

        async created() {
            this.roomId = this.selectedRoomId;
            await this.refresh();

        }
    }
</script>

<style scoped>
    .grid {
        padding: 10px;
    }
</style>
